import { render, staticRenderFns } from "./materialquery.vue?vue&type=template&id=199c7e54&scoped=true"
import script from "./materialquery.vue?vue&type=script&lang=js"
export * from "./materialquery.vue?vue&type=script&lang=js"
import style0 from "./materialquery.vue?vue&type=style&index=0&id=199c7e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199c7e54",
  null
  
)

export default component.exports